/**
 * Dancers filter config (listing-filters convergence, Phase 4).
 *
 * Like auditions, the dancers listing runs on a bespoke cached loader
 * (`get-cached-dancers-listing`), so this builds the UI-only
 * `ListingFilterConfig` directly rather than a DB-facing `defineListing`
 * registry. Only gender + search go through the shared bar; the `level` control
 * stays a surface-managed slot toggle because its "absent = professional"
 * default (BAL-362) doesn't fit the shared hook's "absent = empty" facet model.
 */
import { GENDER_OPTIONS } from '@kit/shared/gender';

import type { ListingFilterConfig } from '~/components/listing-filters/types';

type Translate = (key: string, defaultValue?: string) => string;

export function dancersFilterConfig(t: Translate): ListingFilterConfig {
  return {
    search: {
      placeholder: t('community:dancers.searchPlaceholder', 'Search dancers…'),
    },
    facets: [
      {
        kind: 'dropdown',
        key: 'gender',
        label: t('dancers:filters.gender', 'Gender'),
        // Canonical gender registry (female / male / nonBinary). Empty
        // selection = all genders (the loader treats an absent param as 'all').
        options: GENDER_OPTIONS.map((g) => ({
          value: g.value,
          label: t(`dancers:genders.${g.value}`, g.label),
        })),
      },
    ],
    sorts: [],
    defaultSort: '',
  };
}
